
import React from 'react';
import { Info } from 'lucide-react';

export const AlertIcon: React.FC = () => {
  return <Info className="h-4 w-4 md:h-5 md:w-5 text-blue-600" />;
};
